import {
	postYiqifeiXServicesRequest,
	postBIZServicesRequest,
	postYiqifeiAPIEncryptDataRequest
} from '@/utils/request'
var webconfig = require('@/utils/webconfig.js');

const yqfApi = {
	/**
	 * 获取网站配置
	 * @description 
	 */
	GetWebConfigData(parm, callback) {
		postYiqifeiAPIEncryptDataRequest('/CommonAPI/GetWebConfigData', parm, function(result) {
			callback(result);
		})
	},
	/**
	 * 获取订单列表
	 * @description 
	 */
	GetSalesOrderList(parm, callback) {
		postYiqifeiAPIEncryptDataRequest('/OrderAPIV2/GetSalesOrderList', parm, function(result) {
			callback(result);
		})
	},
	/**
	 * 获取订单列表
	 * @description 
	 */
	GetSalesOrderDetailInfo(parm, callback) {
		postYiqifeiAPIEncryptDataRequest('/OrderAPIV2/GetSalesOrderDetailInfo', parm, function(result) {
			callback(result);
		})
	},
	/**
	 * 查询退票费
	 * @description 
	 */
	GetAirRefundFeeCompute(parm, callback) {
		postYiqifeiAPIEncryptDataRequest('/OrderAPIV2/GetAirRefundFeeCompute', parm, function(result) {
			callback(result);
		})
	},
	/**
	 * 查询退票费（支持多个旅客类型）
	 * @description 
	 */
	GetAirRefundFeeComputeByPassengers(parm, callback) {
		postYiqifeiAPIEncryptDataRequest('/OrderAPIV2/GetAirRefundFeeComputeByPassengers', parm, function(result) {
			callback(result);
		})
	},
	/**
	 * 查询订单进度
	 * @description 
	 */
	GetPSOCustomerDocStatus(parm, callback) {
		postYiqifeiAPIEncryptDataRequest('/OrderAPIV2/GetPSOCustomerDocStatus', parm, function(result) {
			callback(result);
		})
	},
};

export default yqfApi;